import authService from '../services/authService';

export const performLogin = async (credentials) => {
  const result = await authService.login(credentials);
  // Expecting response shape provided by the user
  // { success, message, data: { token, username, roles, expiresAt } }
  if (!result?.success) {
    const error = new Error(result?.message || 'Login failed');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const performChangePassword = async (payload) => {
  const result = await authService.changePassword(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Change password failed');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  performLogin,
  performChangePassword,
};


